import { colors } from "../../colors/color";
import { StyleVariant } from "../AmorgMenuTypes";

export const colorHelper = {
    getForegroundColor:(styleVariant:StyleVariant)=>{
        switch (styleVariant) {
            case "default":
                return `${colors.text.gray.dark}`;
            case "emphasized":
                return `${colors.text.gray.dark}`;
            case "destructive":
                    return `${colors.text.state.error}`;
            case "strike-through":
                return `${colors.text.gray.dark}`;
            default:
                return `${colors.text.gray.dark}`;
        }
    }
};